import { z } from 'zod';
/**
 * Listen-Contracts (07 – Datenmodell / 03 – FA / 08 – Rollen & Rechte).
 * Abgehakt = checkedAt != null. Private Listen sieht nur der Ersteller.
 */
export const LIST_TYPES = ['shopping', 'todo', 'custom'];
export const listDtoSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    type: z.enum(LIST_TYPES),
    isPinned: z.boolean(),
    isPrivate: z.boolean(),
    ownerMemberId: z.string().uuid().nullable(),
    sortOrder: z.number().int(),
    openCount: z.number().int(),
    doneCount: z.number().int(),
});
export const createListSchema = z.object({
    name: z.string().min(1).max(80),
    type: z.enum(LIST_TYPES).optional(),
    isPrivate: z.boolean().optional(),
});
export const updateListSchema = z.object({
    name: z.string().min(1).max(80).optional(),
    isPinned: z.boolean().optional(),
    isPrivate: z.boolean().optional(),
    sortOrder: z.number().int().optional(),
});
export const listItemDtoSchema = z.object({
    id: z.string().uuid(),
    listId: z.string().uuid(),
    text: z.string(),
    note: z.string().nullable(),
    quantity: z.string().nullable(),
    assignedTo: z.string().uuid().nullable(),
    reportedDoneAt: z.string().nullable(), // vom Kind als erledigt gemeldet (wartet auf Bestätigung)
    reportedBy: z.string().uuid().nullable(),
    checkedAt: z.string().nullable(), // von den Eltern bestätigt = erledigt
    checkedBy: z.string().uuid().nullable(),
    createdBy: z.string().uuid().nullable(),
    sortOrder: z.number().int(),
    rewardAmount: z.number().int().nullable(), // Punkte-Aufgaben: = Punkte (1 P = 1 Cent)
    dueAt: z.string().nullable(), // „zu erledigen bis …" (ISO), Punkte-Aufgaben
    templateId: z.string().uuid().nullable(), // Herkunft aus einer Aufgaben-Vorlage
});
export const createListItemSchema = z.object({
    text: z.string().min(1).max(300),
    note: z.string().max(1000).nullable().optional(),
    quantity: z.string().max(40).nullable().optional(),
    assignedTo: z.string().uuid().nullable().optional(),
    rewardAmount: z.number().int().min(0).max(100000).nullable().optional(),
    dueAt: z.string().nullable().optional(),
});
export const updateListItemSchema = z.object({
    text: z.string().min(1).max(300).optional(),
    note: z.string().max(1000).nullable().optional(),
    quantity: z.string().max(40).nullable().optional(),
    assignedTo: z.string().uuid().nullable().optional(),
    checked: z.boolean().optional(), // Eltern-Bestätigung (= erledigt)
    reportDone: z.boolean().optional(), // Kind meldet/zieht zurück (wartet auf Bestätigung)
    rewardAmount: z.number().int().min(0).max(100000).nullable().optional(),
    dueAt: z.string().nullable().optional(),
});
//# sourceMappingURL=lists.js.map